import React from "react";
import type CampaignContact from "@/model/interface/CampaignContact";
import { StatusDot } from "@/components/dialer/components/StatusDot";
import { statusLabel } from "@/components/dialer/components/StatusLabel";
import { formatTime } from "@/util/date";
import { connectSeconds } from "@/util/dialer";
import { getContactDisplayName } from "@/util/string";

export function CompletedCallItem({ lead }: { lead: CampaignContact }) {
  const outcome =
    lead.status === "COMPLETED" && lead.talkSeconds
      ? formatTime(lead.talkSeconds)
      : lead.exitReason ?? statusLabel(lead.status);
  const connectTime = connectSeconds(lead.answeredAt, lead.connectedAt);

  return (
    <div className="flex items-center gap-3 rounded-md px-1 py-2">
      <StatusDot status={lead.status} />
      <span className="min-w-0 flex-1 truncate text-base text-muted-foreground">
        {(lead.contact && getContactDisplayName(lead.contact)) ?? "Unknown"}
      </span>
      <span
        className="shrink-0 text-sm tabular-nums text-muted-foreground"
        title={connectTime ? `Connected ${connectTime} s after the lead answered` : undefined}
      >
        {outcome}
        {connectTime && ` · ${connectTime} s`}
      </span>
    </div>
  );
}
